"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditMetaMatchingConfigurationDialogModule = /** @class */ (function () {
    function EditMetaMatchingConfigurationDialogModule() {
    }
    return EditMetaMatchingConfigurationDialogModule;
}());
exports.EditMetaMatchingConfigurationDialogModule = EditMetaMatchingConfigurationDialogModule;
